D.Cookie = {
  create: function (name, value, days, path) {
    if (!path) {
      path = '/';
    }
    let expires = '';
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + expires + '; path=' + path;
  },

  set: function (name, value, to, path) {
    if (!path) {
      path = '/';
    }
    let date = new Date();
    date.setTime(to * 1000);
    let expires = '; expires=' + date.toUTCString();
    document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + expires + '; path=' + path;
  },

  read: function (name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length, c.length).replace(/\+/g, ' '));
      }
    }
    return null;
  },
  erase: function (name, path) {
    this.create(name, '', -1, path);
  }
};
